import styled from "@emotion/styled";
import { Theme } from "@silvertours/front-shared";
var LogoList = /*#__PURE__*/ styled("ul", {
    target: "e17ihek50"
})("list-style:none;margin:0;padding:0;display:flex;align-items:center;justify-content:space-around;flex-direction:column;gap:1.25rem;", Theme.mq("lg"), "{flex-direction:row;gap:0;}");
var GarantieWrapper = /*#__PURE__*/ styled("a", {
    target: "e17ihek51"
})("position:relative;height:5.625rem;margin-bottom:1.25rem;");
var MgpWrapper = /*#__PURE__*/ styled("li", {
    target: "e17ihek52"
})("height:5.625rem;");
var CarigamiWrapper = /*#__PURE__*/ styled("li", {
    target: "e17ihek53"
})("svg{height:1.688rem;", Theme.mq("md"), "{height:2.375rem;}", Theme.mq("lg"), "{height:3.063rem;}}& #logo-claim{display:none;", Theme.mq("lg"), "{display:block;}}");
export { LogoList, GarantieWrapper, MgpWrapper, CarigamiWrapper };
